import { jsx as _jsx } from "react/jsx-runtime";
import { IconButtonWithTooltip } from "../../../Common/IconButtonWithTooltip";
import { useIcon } from "../../../Icons";
import { useSubstructureInstanceInsertButtonProps } from "./useSubstructureInstanceInsertButtonProps";
/**
 * Insert a new subconfiguration instance at this position in the list
 * @param props
 * @returns
 */
export function SubstructureInstanceInsertButton(props) {
    const DefaultIcon = useIcon("SubstructureAddIcon");
    const { substructure, icon = _jsx(DefaultIcon, {}) } = props;
    const buttonProps = useSubstructureInstanceInsertButtonProps({
        substructure,
    });
    return _jsx(IconButtonWithTooltip, Object.assign({}, buttonProps, { icon: icon }));
}
//# sourceMappingURL=SubstructureInstanceInsertButton.js.map